export * from "./iblShadowsVoxelRenderer.pure";

import "../../Engines/Extensions/engine.multiRender";
